/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action, setProperties } from '@ember/object';
import ObjectAttributeCondition, { ObjectAttributeSource } from 'cio/app-models/conditions/object-attribute';

interface Args {
  attributeSourceOptions?: { label: ObjectAttributeSource; value: string }[];
  disabled: boolean;
  condition: ObjectAttributeCondition;
}

export default class AttributeSource extends Component<Args> {
  @action
  onAttributeSourceChange(source: ObjectAttributeSource) {
    setProperties(this.args.condition, {
      objectAttributeSource: source,
      name: '',
      value: '',
    });

    this.args.condition.applyUpdates();
  }
}
